import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import EditNoteIcon from '@mui/icons-material/EditNote';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';

export const BannerInfoEncuestas = () => {
    return (
        <Paper 
            elevation={0}
            sx={{ 
                mt: 3, 
                p: { xs: 3, md: 4 }, 
                backgroundColor: '#F8F7FA', // Color de fondo muy suave
                borderRadius: 3,
                border: '1px solid #EAEAFF'
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 4, flexWrap: 'wrap', gap: 2 }}>
                <Box sx={{ display: 'flex', gap: 2, flex: 1, minWidth: '300px' }}>
                    <Box 
                        sx={{ 
                            width: 52, 
                            height: 52, 
                            borderRadius: '50%', 
                            backgroundColor: '#E8E7FD', 
                            display: 'flex', 
                            justifyContent: 'center', 
                            alignItems: 'center',
                            flexShrink: 0
                        }}
                    >
                        <AutoAwesomeIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                    </Box>
                    <Box>
                        <Typography variant="h6" sx={{ color: '#696CFF', fontWeight: 700, mb: 0.5, fontSize: '1.15rem' }}>
                            ¿Para qué sirve la configuración de encuestas?
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500, maxWidth: '80%' }}>
                            Crea y personaliza los formularios que se mostrarán en tus dispositivos para recolectar el feedback de los huéspedes de manera eficiente.
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <Grid container spacing={3} sx={{ pl: { xs: 0, sm: 8.5 } }}>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Box sx={{ display: 'flex', gap: 1.5 }}>
                        <EditNoteIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}>
                                Diseño Flexible
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                Agrega preguntas abiertas o cerradas según la necesidad de la encuesta.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Box sx={{ display: 'flex', gap: 1.5 }}>
                        <StarOutlineIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}>
                                Métricas Estándar
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                Usa métricas reconocidas (NPS, CSAT, CES) para medir la satisfacción.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Box sx={{ display: 'flex', gap: 1.5 }}>
                        <PhotoCameraIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}>
                                Contenido Visual
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                Enriquece las preguntas subiendo imágenes de referencia.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    );
};
